import { CoinsTransferArea } from "./components/coin-transfer-area";

export const InfoTransfer = () => {
  const openFromApp = localStorage.getItem("@openFromApp");
  const token = localStorage.getItem("@token");

  if (!token) {
    return null;
  }

  return (
    <div
      style={{
        fontFamily: '"Epilogue", -apple-system, "Segoe UI", sans-serif',
        background: "#F7F1FC",
        minHeight: "100vh",
        color: "#2E1C42",
      }}
    >
      {!openFromApp && (
        <div
          style={{
            background: "linear-gradient(135deg, #9B30E6 0%, #C77DFF 100%)",
            padding: "18px 20px 20px",
            color: "#ffffff",
            borderRadius: "0 0 20px 20px",
            boxShadow: "0 10px 24px rgba(50, 32, 77, 0.2)",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              marginBottom: "6px",
            }}
          >
            <span
              aria-hidden="true"
              style={{
                display: "inline-block",
                width: "18px",
                height: "18px",
                borderRadius: "50%",
                background:
                  "radial-gradient(circle at 35% 30%, #FFE9A8, #F7C948 55%, #DA9E15 100%)",
                border: "2px solid rgba(255,255,255,0.55)",
              }}
            />
            <span
              style={{
                fontWeight: 800,
                fontSize: "14px",
                letterSpacing: "0.04em",
              }}
            >
              Hug
            </span>
          </div>

          <h2 style={{ margin: 0, fontWeight: 800, fontSize: "22px" }}>
            Coins transfer
          </h2>
        </div>
      )}

      <CoinsTransferArea />
    </div>
  );
};
